export enum ExperienceType {
  ACCOMMODATION = 'accommodation',
  EAT_DRINK = 'eat_drink',
  EXPERIENCE = 'experience',
  PLACES_INTEREST = 'places_interest',
  TRANSPORTATION = 'transportation',
  OTHERS = 'others',
}
